<div class="bk-page set">
  <header class="bk-page__head set__head">
    <div class="bk-page__intro">
      <p class="bk-eyebrow">Account</p>
      <h1 class="bk-page__title">Settings</h1>
      <p class="bk-page__sub">{{ description }}</p>
    </div>
  </header>

  <!-- Rebuilt when the tab list changes, so the highlight follows the roles -->
  @for (key of [tabsKey]; track key) {
    <nav class="set__tabs" aria-label="Settings sections">
      <app-routing-tab [tabList]="tabs" />
    </nav>
  }

  <div class="set__body">
    <router-outlet></router-outlet>
  </div>
</div>
